import React from 'react';
import { createPortal } from 'react-dom';

interface TpProps {
  children: React.ReactNode;
}

export function TopBarPortal(props: TpProps) {
  const [domReady, setDomReady] = React.useState(false);

  React.useEffect(() => {
    setDomReady(true);
  });

  if (!domReady) return null;

  const containerElem = document.getElementById('appTopBar');
  if (!containerElem) return null;

  const wrapper = <div>{props.children}</div>;
  return createPortal(wrapper, containerElem);
}
